
export const agentStore = {
    namespaced: true,
    actions: {
      async executeChatbotRequest (_, data) {
        try {
          const token = localStorage.getItem('access-token')
          const response = await fetch(`${process.env.VUE_APP_API_AI_SERVICE}/agent/request`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(data)
          })
          const resp = await response.json()
          if (resp.success !== 200) {
            console.error('Ha ocurrido un error, intente más tarde o contacte al administrador')
          }
          return resp
        } catch (error) {
          console.error(error)
        }
      },
      async getPermission () {
        try {
          const token = localStorage.getItem('access-token')
          const response = await fetch(`${process.env.VUE_APP_API_AI_SERVICE}/agent/validate`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          })
          const resp = await response.json()
          if (resp.success !== 200) {
            console.error('Ha ocurrido un error, intente más tarde o contacte al administrador')
          }
          return resp
        } catch (error) {
          console.error(error)
        }
      },
      async getHistory () {
        try {
          const token = localStorage.getItem('access-token')
          const response = await fetch(`${process.env.VUE_APP_API_AI_SERVICE}/agent/history`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          })
          const resp = await response.json()
          if (resp.success !== 200) {
            console.error('Ha ocurrido un error, intente más tarde o contacte al administrador')
          }
          return resp
        } catch (error) {
          console.error(error)
        }
      }
    }
}